import { FormattedMessage, useIntl } from 'react-intl';

import { openPreconditionsDialog } from '@/features/app/MessageHandler';
import { ENGINE_OIL_STATE, SOURCE_DEVICE, STATUS } from '@/features/engineoil/utils/constants';
import { getIconColor, getIconName, getThresholdClass, isEngineOilOutdated } from '@/features/engineoil/utils/utils';
import type { EngineOil } from '@/generated/GeneratedApiTypes';
import AnalyticsEvents from '@/utils/analytics/AnalyticsEvents';
import ActiveDtcTag from './ActiveDtcTag';
import BasePanel from './BasePanel';
import ReadingNotPossible from './ReadingNotPossible';

const Cm4SensorSignalSeriesSCSCard = ({ engineOil }: { engineOil: EngineOil }) => {
    const intl = useIntl();
    const { state, status, measured_at, active_dtc } = engineOil;

    const isReadingNotPossible = isEngineOilOutdated(measured_at.date);
    const hasActiveDtc = active_dtc != null;
    const iconName = getIconName(status);
    const calloutVariant =
        state !== ENGINE_OIL_STATE.OK ? getThresholdClass(status, isReadingNotPossible, hasActiveDtc) : '';

    return (
        <BasePanel
            timestamp={measured_at.date}
            mileage={measured_at.mileage_km}
            isReadingNotPossible={isReadingNotPossible}
            testId="card-customer-cm4-sensor_signal_series-service_care_s"
        >
            <div className="space-y-10">
                {hasActiveDtc && (
                    <ActiveDtcTag
                        dtcType={active_dtc!.type}
                        onHoverIntent={() => AnalyticsEvents.hoverSensorSignalSSidebarCriticLow(SOURCE_DEVICE.CM4)}
                    />
                )}

                {isReadingNotPossible && (
                    <ReadingNotPossible
                        onHoverIntent={() => AnalyticsEvents.hoverSensorSignalSidebarOlder24h(SOURCE_DEVICE.CM4)}
                    />
                )}
            </div>

            <div
                className={`display-flex justify-content-between align-items-center ${
                    calloutVariant ? `callout callout-${calloutVariant}` : ''
                } padding-10 margin-top-10 margin-bottom-10`}
            >
                <div className={`display-flex align-items-center ${status === STATUS.NORMAL ? 'padding-left-10' : ''}`}>
                    {iconName && (
                        <span
                            className={`uikit-icon ${iconName} ${getIconColor(status)} text-size-14 margin-right-5`}
                        />
                    )}
                    <span className="text-size-14 text-color-darkest">
                        <FormattedMessage id={`intl-msg:engineOil.state.${state}`} />
                    </span>
                </div>

                <a
                    href="#"
                    className="text-color-primary"
                    onClick={(e) => {
                        e.preventDefault();
                        AnalyticsEvents.openSensorSignalSPreconditionsDialog(SOURCE_DEVICE.CM4);
                        openPreconditionsDialog(
                            engineOil.asset_id,
                            intl.formatMessage({ id: 'intl-msg:engineOil.preconditions.dialog.title' }),
                        );
                    }}
                >
                    <FormattedMessage id="intl-msg:engineOil.seeReadingPreconditions" />
                </a>
            </div>
        </BasePanel>
    );
};

export default Cm4SensorSignalSeriesSCSCard;
